export default __webpack_public_path__ + "static/silvano-8ba8f55d9ac8800e16a95d6397765016.png";